import { ButtonType, type ButtonInteractiveProps } from './ButtonInteractive.types';

export const buttonInteractiveDefaults: ButtonInteractiveProps = {
  isDisabled: false,
  text: '',
  buttonType: ButtonType.Button,
  isVisible: true,
  isToggle: false,
  isLoading: false,
};
